<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @search-reset="searchClear"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button icon="el-icon-plus" type="primary" size="small" plain @click.stop="handleAdd()">新增商品</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="success"
            size="small"
            icon="el-icon-view"
            plain
            @click.stop="handleDetail(scope.row,scope.index)"
          >查看</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            v-if="scope.row.productStatus ==='NOT_SELL'"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="danger"
            v-if="scope.row.productStatus ==='NOT_SELL'"
            size="small"
            icon="el-icon-delete"
            plain
            @click.stop="delProduct(scope.row.id)"
          >删除</el-button>
        </template>
        <template slot-scope="scope" slot="search">
          <el-form-item label="品牌名称" size="small" style="margin-top: 4px">
            <el-col :md="32">
              <el-select v-model="searchBrand" placeholder="请选择品牌" value-key="id">
                <el-option
                  v-for="brand in brands"
                  :key="brand.id"
                  :label="brand.name"
                  :value="brand"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>
        <template slot-scope="scope" slot="brandNameForm">
          <el-select v-model="brand" placeholder="请选择品牌" value-key="id">
            <el-option v-for="brand in brands" :key="brand.id" :label="brand.name" :value="brand"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="firstClassifyNameForm">
          <el-select
            v-model="classify"
            placeholder="请选择商品一级分类"
            required
            :disabled="isEdit"
            @change="chooseSecondClassify"
            value-key="id"
          >
            <el-option
              v-for="classify in classifies"
              :key="classify.id"
              :label="classify.name"
              :value="classify"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="secondClassifyNameForm">
          <el-select
            v-model="secondClassify"
            placeholder="请选择商品二级分类"
            :disabled="isEdit"
            required
            @change="findProductSkuClassify"
            value-key="id"
          >
            <el-option
              v-for="secondClassify in secondClassifies"
              :key="secondClassify.id"
              :label="secondClassify.name"
              :value="secondClassify"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="skuForm">
          <el-select
            v-model="sku"
            placeholder="请选择SKU组合"
            :disabled="isEdit"
            required
            @change="findConstituteBySkuId"
            value-key="id"
          >
            <el-option v-for="sku in skuList" :key="sku.id" :label="sku.skuName" :value="sku"></el-option>
          </el-select>
        </template>
        <!--<template slot-scope="scope" slot="agentIdForm">-->
        <!--<el-select v-model="department"-->
        <!--placeholder="请选择代理商"-->
        <!--required-->
        <!--value-key="dutyStuff">-->
        <!--<el-option v-for="department in departments" :key="department.dutyStuff"-->
        <!--:label="department.company"-->
        <!--:value="department"></el-option>-->
        <!--</el-select>-->
        <!--</template>-->
        <template slot-scope="scope" slot="joinsWorkServiceCategoryForm">
          <el-select
            v-model="joinsWorkServiceCategory"
            placeholder="请选择服务类目"
            required
            @change="choseWorkServiceItem"
            value-key="id"
          >
            <el-option
              v-for="joinsWorkServiceCategory in joinsWorkServiceCategorys"
              :key="joinsWorkServiceCategory.id"
              :label="joinsWorkServiceCategory.name"
              :value="joinsWorkServiceCategory"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="joinsWorkServiceItemForm">
          <el-select
            v-model="joinsWorkServiceItem"
            placeholder="请选择服务项目"
            required
            @change="findCoupon"
            value-key="id"
          >
            <el-option
              v-for="joinsWorkServiceItem in joinsWorkServiceItems"
              :key="joinsWorkServiceItem.id"
              :label="joinsWorkServiceItem.name"
              :value="joinsWorkServiceItem"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="couponForm">
          <el-select
            v-model="coupon"
            placeholder="请选择优惠券"
            required
            @change="findCoupon"
            value-key="id"
          >
            <el-option
              v-for="coupon in coupons"
              :key="coupon.id"
              :label="coupon.couponName"
              :value="coupon"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="productStatusForm">
          <div>
            <el-radio v-model="productStatus" label="PUTAWAY">上架</el-radio>
            <el-radio v-model="productStatus" label="UNDERCARIAGE">下架</el-radio>
          </div>
        </template>
        <template slot-scope="scope" slot="dispatchingForm">
          <div>
            <el-radio v-model="dispatching" label="EXPRESS">快递</el-radio>
            <el-radio v-model="dispatching" label="MERCHANT">商家配送</el-radio>
          </div>
        </template>
        <template slot-scope="{}" slot="thirdNameForm">
          <div style="display:flex;">
            <el-tooltip
              class="item"
              effect="dark"
              content="第三方平台的名称及售价将会在消费者端展示，如京东价xx元，淘宝价xx元."
              placement="top-start"
            >
              <i class="el-icon-warning" style="position: relative;left: -8px;"></i>
            </el-tooltip>
            <el-input placeholder="请输入第三方平台名称" v-model="form.thirdName"></el-input>
          </div>
        </template>
        <template slot-scope="scope" slot="mainImageForm">
          <el-upload
            :multiple="true"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList0"
            :http-request="fnUploadMainImage"
            :show-file-list="false"
          >
            <div v-if="mainImage!=''&&mainImage!=null " class="el-upload el-upload--picture-img">
              <img :src="mainImage" style="width: 200px;" />
              <a style="margin-left: 20px" @click.stop="deleteMain(mainImage)">删除</a>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传一张jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="describeImgsForm">
          <el-upload
            :multiple="true"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList"
            :http-request="fnUploadDescribeImgs"
            :show-file-list="false"
          >
            <div v-if="'' != describeImgs" class="el-upload el-upload--picture-img">
              <div :key="describeImg.id" v-for="describeImg of describeImgs">
                <img :src="describeImg" style="width: 200px;" />
                <a style="margin-left: 20px" @click.stop="deleteDes(describeImg)">删除</a>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="wheelsImgsForm">
          <el-upload
            :multiple="true"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList1"
            :http-request="fnUploadWheelsImgs"
            :show-file-list="false"
          >
            <div v-if="'' != wheelsImgs" class="el-upload el-upload--picture-img">
              <div :key="wheelsImg.id" v-for="wheelsImg of wheelsImgs">
                <img :src="wheelsImg" style="width: 200px;" />
                <a style="margin-left: 20px" @click.stop="deletePic(wheelsImg)">删除</a>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="constituteForm">
          <div>
            <el-table :data="constitutes" border>
              <template v-for="(col,index) in tableData1">
                <el-table-column
                  sortable
                  :show-overflow-tooltip="true"
                  :prop="col.dataItem"
                  :label="col.dataName"
                  :key="col.dataItem"
                  width="124px"
                >
                  <template slot-scope="scope">
                    <!-- <el-input
                      type="input"
                      :name="col.dataName"
                      v-model="scope.row[index]"
                      :placeholder="col.placeholder"
                    ></el-input>-->
                    <el-input
                      type="input"
                      v-if="col.dataName==='库存'"
                      :name="col.dataName"
                      v-model="scope.row[index]"
                      :placeholder="col.placeholder"
                    ></el-input>
                    <el-input
                      type="input"
                      v-else
                      :name="col.dataName"
                      v-model="scope.row[index]"
                      :placeholder="col.placeholder"
                    ></el-input>
                  </template>
                </el-table-column>
              </template>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-close"
                    size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
              <el-button @click="handleAddRows()">增加一行</el-button>
            </div>
          </div>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commerceGoodsOption } from "@/const/salesCloud/commerceGoodsOption";
import {
  findProductGoods,
  addProductGoods,
  delProduct,
  findProductGoodsById,
  productDown,
  productPutAway,
  updateProduct,
  findProductSkuClassify,
  findConstituteBySkuId,
  findBrand,
  findBrand1,
  chooseSecondClassify,
  findClassify
} from "@/api/salesCloud/commerceGoods";
import {
  findCategoryAll,
  findItemsByCategory
} from "@/api/salesCloud/workOrder";
import { findCoupon } from "@/api/salesCloud/serviceCoupon";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  name: "commerceGoods",
  data() {
    return {
      tableOption: commerceGoodsOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      productStatuses: DIC.PRODUCT_STATUS,
      brands: [],
      brand: {},
      searchBrand: {},
      form: {},
      classifies: [],
      isAbled: true,
      changeSku: false,
      classify: {},
      secondClassifies: [],
      secondClassify: {},
      departments: [],
      department: {},
      isEdit: false,
      productStatus: "PUTAWAY",
      dispatching: "EXPRESS",
      describeImgs: [],
      wheelsImgs: [],
      fileList0: [],
      mainImage: "",
      fileList: [],
      fileList1: [],
      prices: [],
      clientTypes: DIC.CLIENT_TYPE,
      sku: {},
      skuList: [],
      tableData1: [],
      constitutes: [],
      dataSku1: [],
      joinsWorkServiceCategorys: [],
      joinsWorkServiceCategory: {},
      joinsWorkServiceItems: [],
      joinsWorkServiceItem: {},
      coupon: {},
      coupons: []
    };
  },
  created() {
    findBrand1().then(res => {
      let data = JSON.parse(res.data);
      this.brands =data;
    });
    findClassify().then(res => {
      let data = JSON.parse(res.data);
      this.classifies = data;
    });
    findCategoryAll().then(res => {
      let data = JSON.parse(res.data);
      this.joinsWorkServiceCategorys = data.rows;
    });
    // findAllSuperiorDepartment().then((res) => {
    //     let data = JSON.parse(res.data);
    //     this.departments = data
    // });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    searchClear() {
      this.searchBrand = {};
    },
    deleteMain() {
      this.mainImage = "";
    },
    deleteDes(describeImg) {
      let index = this.describeImgs.indexOf(describeImg);
      if (index > -1) {
        this.describeImgs.splice(index, 1);
      }
    },
    deletePic(wheelsImg) {
      let index = this.wheelsImgs.indexOf(wheelsImg);
      if (index > -1) {
        this.wheelsImgs.splice(index, 1);
      }
    },
    delProduct(id) {
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          delProduct(id)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    handleAddRows() {
      let obj = "{";
      for (let i = 0; i < this.tableData1.length; i++) {
        if (i != this.tableData1.length - 1) {
          obj += "" + i + ":'',";
        } else {
          obj += "" + i + ":''";
        }
      }
      obj += "}";
      let dataObj = eval("(" + obj + ")");
      // let list = {
      //     price: '',
      //     goodsNumber:0,
      //     consumerDiscount:'',
      //     engineerDiscount:'',
      //     merchantDiscount:''
      // }
      this.constitutes.push(dataObj);
    },
    handleSteppingDelete(index, row) {
      this.constitutes.splice(index, 1);
      this.dataSku1.splice(index, 1);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findProductGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findProductGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;

      if (null != this.searchBrand.id && undefined != this.searchBrand.id) {
        params.brandId = this.searchBrand.id;
      } else {
        delete params.brandId;
      }
      findProductGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findProductGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.prices = [];
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.clean();
      this.isEdit = false;
      this.constitutes = [];
      this.form.thirdName = row.thirdName;
      this.brand = { id: row.brandId };
      this.classify = { id: row.firstClassifyId };
      chooseSecondClassify(this.classify.id).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
        this.secondClassify = { id: row.secondClassifyId };
        let obj = {};
        obj.firstClassifyId = this.classify.id;
        obj.secondClassifyId = this.secondClassify.id;
        findProductSkuClassify(obj).then(res => {
          let data = JSON.parse(res.data);
          this.skuList = data;
          this.sku = { id: row.dataSku[0].skuId };
        });
      });
      findConstituteBySkuId(row.skuId).then(res => {
        let data = JSON.parse(res.data);
        this.formatConstitute(data);
        this.dataSku1 = row.dataSku;
        console.log(row)
        for (let i = 0; i < row.dataSku.length; i++) {
          let mapObj = new Map();
          let dataSku = row.dataSku[i];
          let map = this.objToStrMap(dataSku);
          let arrayVal = map.get("skuValue").split(":");
          let tableData2 = this.tableData1;
          for (let j = 0; j < tableData2.length; j++) {
            let obj1 = tableData2[j];
            if (typeof obj1.id != "undefined") {
              mapObj.set(obj1.flag, arrayVal[obj1.flag]);
            } else {
              mapObj.set(obj1.flag, map.get(obj1.dataItem));
            }
          }
          this.constitutes.push(this.strMapToObj(mapObj));
        }
      });
      this.mainImage = row.mainImage;
      this.department = { dutyStuff: row.agentId };
      this.describeImgs = row.describeImgs;
      if (this.describeImgs == null) {
        this.describeImgs = [];
      }

      this.wheelsImgs = row.wheelsImgs;
      if (this.wheelsImgs == null) {
        this.wheelsImgs = [];
      }

      this.productStatus = row.productStatus;
      this.dispatching = row.dispatching;
      // row.goodsNumber = row.goodsNumber
      // row.price = row.price
      // row.jdPrice = row.jdPrice
      row.consumerDiscount = row.consumerDiscount;
      row.engineerDiscount = row.engineerDiscount;
      row.merchantDiscount = row.merchantDiscount;
      this.joinsWorkServiceCategory = { id: row.serviceCategoryId };
      this.choseWorkServiceItem();
      this.joinsWorkServiceItem = { id: row.serviceItemId };
      this.findCoupon();
      this.coupon = { id: row.couponId };
      // this.prices = row.prices
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findProductGoods(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      let dataSku = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.skuId = this.sku.id;
        dataSku.push(sku);
      }
      //sku组合
      row.dataSku = dataSku;
      //品牌id
      row.brandId = this.brand.id;
      // 一级分类id
      row.firstClassifyId = this.classify.id;
      // 二级分类id
      row.secondClassifyId = this.secondClassify.id;
      //sku组合id
      row.skuId = this.sku.id;
      //第三方平台名称
      row.thirdName = this.form.thirdName;

      // row.productStatus = this.productStatus;
      // row.dispatching = this.dispatching;
      // row.couponId = this.coupon.id;
      // 主图
      row.mainImage = this.mainImage;
      row.agentId = this.department.dutyStuff;
      // 描述图
      row.describeImgs = this.describeImgs;
      // 轮播图
      row.wheelsImgs = this.wheelsImgs;
      //产品名称,产品单位第三方平台价格
      addProductGoods(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      let dataSku = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.skuId = this.sku.id;
        if (row.dataSku[i]) {
          if(!this.changeSku)
          {
            console.log(this.changeSku)
            sku.id = row.dataSku[i].id;
          }
        }

        dataSku.push(sku);
      }
      row.dataSku = dataSku;
      row.brandId = this.brand.id;
      row.firstClassifyId = this.classify.id;
      row.secondClassifyId = this.secondClassify.id;
      row.productStatus = this.productStatus;
      row.dispatching = this.dispatching;
      row.agentId = this.department.dutyStuff;
      row.describeImgs = this.describeImgs;
      row.wheelsImgs = this.wheelsImgs;
      row.couponId = this.coupon.id;
      row.mainImage = this.mainImage;
      row.thirdName = this.form.thirdName;
      updateProduct(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    handleDetail(row, index) {
      this.clean();
      this.isEdit = true;
      this.constitutes = [];
      this.form.thirdName = row.thirdName;
      this.brand = { id: row.brandId };
      this.classify = { id: row.firstClassifyId };
      chooseSecondClassify(this.classify.id).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
        this.secondClassify = { id: row.secondClassifyId };
        let obj = {};
        obj.firstClassifyId = this.classify.id;
        obj.secondClassifyId = this.secondClassify.id;
        findProductSkuClassify(obj).then(res => {
          let data = JSON.parse(res.data);
          this.skuList = data;
          this.sku = { id: row.dataSku[0].skuId };
        });
      });
      findConstituteBySkuId(row.skuId).then(res => {
        let data = JSON.parse(res.data);
        this.formatConstitute(data);

        this.sku = { id: row.skuId };
        this.dataSku1 = row.dataSku;
        for (let i = 0; i < row.dataSku.length; i++) {
          let mapObj = new Map();
          let dataSku = row.dataSku[i];
          let map = this.objToStrMap(dataSku);
          let arrayVal = map.get("skuValue").split(":");
          let tableData2 = this.tableData1;
          for (let j = 0; j < tableData2.length; j++) {
            let obj1 = tableData2[j];
            if (typeof obj1.id != "undefined") {
              mapObj.set(obj1.flag, arrayVal[obj1.flag]);
            } else {
              mapObj.set(obj1.flag, map.get(obj1.dataItem));
            }
          }
          this.constitutes.push(this.strMapToObj(mapObj));
        }
      });
      this.department = { dutyStuff: row.agentId };
      this.describeImgs = row.describeImgs;
      if (this.describeImgs == null) {
        this.describeImgs = [];
      }

      this.wheelsImgs = row.wheelsImgs;
      if (this.wheelsImgs == null) {
        this.wheelsImgs = [];
      }
      this.mainImage = row.mainImage;
      this.productStatus = row.productStatus;
      this.dispatching = row.dispatching;
      // row.goodsNumber = row.goodsNumber
      // row.price = row.price
      // row.jdPrice = row.jdPrice
      row.consumerDiscount = row.consumerDiscount;
      row.engineerDiscount = row.engineerDiscount;
      row.merchantDiscount = row.merchantDiscount;
      this.joinsWorkServiceCategory = { id: row.serviceCategoryId };
      this.choseWorkServiceItem();
      this.joinsWorkServiceItem = { id: row.serviceItemId };
      this.findCoupon();
      this.coupon = { id: row.couponId };
      // this.prices = row.prices
      this.$refs.crud.rowView(row, index);
    },
    chooseSecondClassify() {
      chooseSecondClassify(this.classify.id).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
        this.secondClassify = "";
        this.sku = "";
        this.tableData1 = "";
        this.constitutes = [];
      });
    },
    async fnUploadWheelsImgs(option) {
      /* if (this.wheelsImgs.length >= 5) {
        this.$message({
          showClose: true,
          message: "轮播图不能超过五张",
          type: "error"
        });
        return;
      } */
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            console.log(results)
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.wheelsImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {});
      });
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      console.log(option)
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client 
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {});
      });
    },
    // 主图只能上传一张
    async fnUploadMainImage(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList0 = files;
            let array = results.res.requestUrls[0].split("?");
            this.mainImage = array[0];
            this.tableLoading = false;
          })
          .catch(err => {});
      });
    },

    productDown() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          productDown(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    productPutAway() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认上架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          productPutAway(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    singleProductPutAway(id) {
      this.$confirm(`是否确认上架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          productPutAway(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    singleProductDown(id) {
      this.$confirm(`是否确认下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          productDown(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    findProductSkuClassify() {
      let obj = {};
      obj.firstClassifyId = this.classify.id;
      obj.secondClassifyId = this.secondClassify.id;
      findProductSkuClassify(obj).then(res => {
        let data = JSON.parse(res.data);
        this.skuList = data;
        this.sku = "";
        this.tableData1 = "";
        this.constitutes = [];
      });
    },
    findConstituteBySkuId() {
      this.changeSku = true;
      this.tableData1 = "";
      this.constitutes = [];
      findConstituteBySkuId(this.sku.id).then(res => {
        let data = JSON.parse(res.data);
        this.formatConstitute(data);
      });
    },
    formatConstitute(data) {
      let flag = 0;
      this.tableData1 = new Array(data.length + 1);
      for (let i = 0; i < data.length; i++) {
        let obj = {};
        obj.dataItem = data[i].constituteCode;
        obj.dataName = data[i].constituteName;
        obj.placeholder = data[i].constituteName;
        obj.id = data[i].id;
        obj.flag = flag;
        this.tableData1[flag] = obj;
        //this.tableData1.push(obj)
        flag++;
      }
      this.tableData1[flag] = {
        dataItem: "goodsNumber",
        dataName: "库存",
        placeholder: "库存",
        flag: flag
      };
      console.dir(this.tableData1, 43434);
    },
    objToStrMap(obj) {
      let strMap = new Map();
      for (let k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
      }
      return strMap;
    },
    strMapToObj(strMap) {
      let obj = Object.create(null);
      for (let [k, v] of strMap) {
        obj[k] = v;
      }
      return obj;
    },
    choseWorkServiceItem() {
      findItemsByCategory(this.joinsWorkServiceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
      });
    },
    findCoupon() {
      let obj = {};
      obj.serviceCategoryId = this.joinsWorkServiceCategory.id;
      obj.serviceItemId = this.joinsWorkServiceItem.id;
      findCoupon(obj).then(res => {
        let data = JSON.parse(res.data);
        this.coupons = data;
      });
    },
    clean() {
      this.changeSku = false;
      this.brand = {};
      this.classify = {};
      this.secondClassify = {};
      this.sku = {};
      this.form = {};
      this.constitutes = [];
      this.joinsWorkServiceCategory = {};
      this.joinsWorkServiceItem = {};
      this.coupon = {};
      this.skuList = [];
      this.tableData1 = [];
      this.constitutes = [];
      this.dataSku1 = [];
      this.describeImgs = [];
      this.wheelsImgs = [];
      this.mainImage = "";
      this.isEdit = false;
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
